import {useCallback, useContext} from 'react';
import {useDispatch, useSelector, useStore} from 'react-redux';
import {Button} from '~library/atoms/Button';
import {LoadingOverlay} from '~library/molecules/LoadingOverlay';
import {navigateToRoute, useCurrentRoute} from '~/CreateFabricGreetingCard/navigation';
import {
  selectIsPremium,
  selectIsProOrPartyPass,
} from '~/CreateFabricGreetingCard/reducers/fabricTemplate/selectors';
import {selectSavingStep} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {toastAlert} from '~library/atoms/Toast';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';
import {FabricContext} from '~/common/fabric/context/FabricContext';
import {CardFeaturesPanel} from '~/common/fabric/CreateDesign/components/NavBottom/CardFeaturesPanel';
import {useUyo} from '~/common/fabric/Card/hooks/useUyo';

import './NavBottom.sass';

export const NavBottom = () => {
  const store = useStore();
  const isPremium = useSelector(selectIsPremium);
  const isProOrPartyPass = useSelector(selectIsProOrPartyPass);
  const savingStep = useSelector(selectSavingStep);
  const currentRoute = useCurrentRoute();
  const {canvas} = useContext(FabricContext);
  const dispatch = useDispatch();
  const {isUyo, pristineUyo} = useUyo();

  const stopSubmitting = () => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {savingStep: false},
    });
  };

  const onClickHandler = useCallback(async () => {
    let errorState = false;

    if (isUyo && pristineUyo) {
      stopSubmitting();
      const toastId = 'design__toast__photo';

      // This will prevent showing multiple toasts for this action
      if (!document.getElementById(toastId)) {
        toastAlert('Please upload photo on front card before continuing', {
          type: 'error',
          icon: <AlertLineIcon ratio={0.65} />,
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          id: toastId,
        });
      }
      errorState = true;
    }

    if (!errorState) {
      const navigating = await navigateToRoute(currentRoute.nextRoute, store);
      if (!navigating) stopSubmitting();
    }
  }, [canvas, store, isPremium, navigateToRoute, currentRoute, pristineUyo]);

  const onClick = () => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {savingStep: true},
    });
    onClickHandler();
  };

  return (
    <div className="create-design__nav-bottom">
      <div className="create-design__nav-bottom__buttons_wrapper">
        <div className="create-design__nav-bottom__panel">
          {(isPremium || isProOrPartyPass) && <CardFeaturesPanel />}
        </div>
      </div>

      <div className="create-design__nav-bottom__cta_wrapper">
        {currentRoute.customButton ? (
          currentRoute.customButton(onClick, {className: 'create-design__nav-bottom__next'})
        ) : (
          <Button
            id="navBottom"
            className="create-design__nav-bottom__next"
            data-qa-id="nav-bottom-next"
            variant="primary"
            size="large"
            onClick={onClick}
          >
            {currentRoute.nextButtonText}
          </Button>
        )}
      </div>
      <LoadingOverlay loadingMessage="Saving..." show={savingStep} />
    </div>
  );
};
